module.exports = __webpack_public_path__ + "static/media/layer-minus.11041f2a.svg";